import React, { useState, useEffect } from "react";
import axios from "axios";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from 'components/Grid/GridItem.js';

import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput";

// @material-ui/icons
import Close from "@material-ui/icons/Close";
import { infoColor } from "assets/jss/material-dashboard-pro-react.js";

// core components
import Button from "components/CustomButtons/Button.js";
import Confirm from 'views/component/Confirm.js';

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";

const customStyle = {
    right: { float: 'right' },
    modalTitle: { color: infoColor[0], fontWeight: 'bold' },
    modalHeader: { borderBottom: '2px solid ' + infoColor[0] },
    select: { minWidth: '200px' }
}
const defaultStyles = makeStyles(selectStyles);
const useStyles = makeStyles(modalStyle);
const customStyles = makeStyles(customStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function WorkCalendarPopup(props) {
    const { modal, onSave, onClose } = props;
    const classes = { ...useStyles(), ...defaultStyles(), ...customStyles() };

    const today = new Date().toISOString().substr(0, 10);
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [startTime, setStartTime] = useState(9);
    const [endTime, setEndTime] = useState(18);

    const setModal = function (modal) {
        onClose(modal);
    }

    const handleSave = function () {
        onSave(startDate, endDate, startTime, endTime);
        onClose(false);
    }

    return (
        <Dialog classes={{ root: classes.center, paper: classes.modal }}
            open={modal} transition={Transition} keepMounted
            onClose={() => setModal(false)}
            aria-labelledby="modal-slide-title" aria-describedby="modal-slide-description" >
            <DialogTitle id="classic-modal-slide-title" disableTypography className={classes.modalHeader}>
                <Button justIcon className={classes.modalCloseButton} key="close"
                    aria-label="Close" color="transparent" onClick={() => setModal(false)}>
                    <Close className={classes.modalClose} />
                </Button>
                <h4 className={classes.modalTitle}>근무시간 일괄 입력</h4>
            </DialogTitle>
            <DialogContent id="modal-slide-description" className={classes.modalBody}>
                <GridContainer>
                    <GridItem>
                        <FormControl className={classes.selectFormControlInfo}>
                            <CustomInput labelText={"시작일"} formControlProps={{ fullWidth: true }}
                                inputProps={{ value: startDate, type: 'date', onChange: e => setStartDate(e.target.value) }}
                                underlineColor="info" />
                        </FormControl>
                        <FormControl className={classes.selectFormControlInfo}>
                            <CustomInput labelText={"종료일"} formControlProps={{ fullWidth: true }}
                                inputProps={{ value: endDate, type: 'date', onChange: e => setEndDate(e.target.value) }}
                                underlineColor="info" />
                        </FormControl>
                    </GridItem>
                    <GridItem>
                        <FormControl className={classes.selectFormControlInfo}>
                            <CustomInput labelText={"시작시간"} formControlProps={{ fullWidth: true }}
                                inputProps={{ value: startTime, type: 'number', onChange: e => setStartTime(e.target.value) }}
                                underlineColor="info" />
                        </FormControl>
                        <FormControl className={classes.selectFormControlInfo}>
                            <CustomInput labelText={"종료시간"} formControlProps={{ fullWidth: true }}
                                inputProps={{ value: endTime, type: 'number', onChange: e => setEndTime(e.target.value) }}
                                underlineColor="info" />
                        </FormControl>
                    </GridItem>
                    <GridItem>
                        <Button color='info' onClick={() => { handleSave() }}>생성</Button>
                    </GridItem>
                </GridContainer>
            </DialogContent>
        </Dialog>
    );
}